module.exports = __webpack_public_path__ + "img/5a63d8f09e140d0123e55a23d0500861.png";